import { Button } from '@mui/material';
import BaseTable from 'components/ui/tables/BaseTable';
import { memo, useCallback, useEffect, useState } from 'react';

import SimpleSearchInput from 'components/SearchInputNavbar';
import { useParams } from 'react-router-dom';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

const Products = () => {
  const { id } = useParams();
  const [refetch, setRefetch] = useState(false);
  const [open, setOpen] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [totalSum, setTotalSum] = useState(0);
  const [totalVal, setTotalVal] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    const fetchTotal = async () => {
      try {
        const res = await axiosPrivate.get(`/admin/warehouses/show/${id}`, {
          signal: controller.signal,
        });
        const data = res.data?.data || [];
        const totalSum = data.reduce((sum, item) => {
          return sum + Number(item.parties_total_sum);
        }, 0);
        const totalVal = data.reduce((sum, item) => {
          return sum + Number(item.parties_total_valute);
        }, 0);
        setTotalSum(totalSum);
        setTotalVal(totalVal);
      } catch (err) {
        if (err.name === 'AbortError') return;
        console.error('Error fetching total sum:', err);
      }
    };

    if (!totalSum || !totalVal) fetchTotal();

    return () => controller.abort(); // Cleanup
  }, [id, totalSum, totalVal]);

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 flex gap-2 items-center justify-center'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          emitTableColumns={{ open, setOpen }}
          dataPath={`admin/warehouses/show/${id}`}
          tableName='admin/warehouses/show/'
          headCells={[
            { code: 'id', label: '#' },
            { code: 'product', label: 'Nomi' },
            { code: 'amount', label: 'Soni' },
            { code: 'parties_text', label: 'Partiyalar' },
          ]}
          columns={[
            { code: 'id' },
            { code: 'product', type: 'nested', childStr: 'name' },
            { code: 'amount' },
            { code: 'parties_text' },
          ]}
          noActions
        />
      </div>
      <div className='w-full px-4 py-2 text-right font-semibold'>
        Jami summa:{' '}
        <span className='text-green-600'>{totalSum.toLocaleString()}</span>
      </div>
      <div className='w-full px-4 py-2 text-right font-semibold'>
        Jami Valyuta:{' '}
        <span className='text-green-600'>{totalVal.toLocaleString()}</span>
      </div>
    </div>
  );
};

export default memo(Products);
